import { __decorate } from "tslib";
import User from '@/types/User/User';
import { Component, Vue } from 'vue-property-decorator';
let ImpersonationButton = class ImpersonationButton extends Vue {
    impersonateUser() {
        //Retrieve the user objects
        this.$store.dispatch('getAllUsers').then((result) => {
            const user = result.data.find((obj) => obj.id === this.$props.userId);
            if (user !== undefined) {
                const impersonateUser = new User(user); //set the user object as impersonated user
                this.$store.dispatch("impersonateUser", impersonateUser);
                this.$store.dispatch("getMyTariffs");
                this.$router.push({ query: { impersonate: this.$props.userId } });
            }
        }).catch((err) => {
            window.errorHandler.logError(err, 'components/ImpersonationButton.vue -> impersonateUser');
        });
    }
};
ImpersonationButton = __decorate([
    Component({
        props: ['userId'],
        data() {
            return {};
        },
        computed: {},
    })
], ImpersonationButton);
export default ImpersonationButton;
